<template>
	<div class="root">
		<MeetingHeader/>
		<div class="ResultBox">
			<Result @go="go" :Orders="orders" goPayText="重新支付" goOtherText="再次预约"></Result>
		</div>
	</div>
</template>

<script>
	import MeetingHeader from '@/components/header/MeetingHeader'
	import Result from '@/components/common/Result'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				orders:[]
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			MeetingHeader,
			Result,
		},
		computed: {
			...mapState({
				userInfo: state => state.common.userInfo,
			}),
		},
		methods: {
			...mapActions([
				'getReservationDetailAction'
			]),
			async initData(){
				const BookingId = Number(sessionStorage.getItem('BookingId')) || null
				if(!BookingId){
					let ss_007 = await this.getReservationDetailAction({
						BookingId:3543
					})
					if(ss_007 && ss_007.length){
						this.orders = ss_007.filter(item => item.OrderStatus?.toLowerCase() == "pay");
						this.orderno = this.orders[0]?.OrderNo
						this.StoreName = this.orders[0]?.StoreName
					}else{
						this.$router.replace('/meeting/orders')
					}
				}
			},
			go(val){
				if(val == 0) this.$router.push(`/meeting/payment?code=${this.$route.query?.code}`)
				if(val == 2) this.$router.push('/meeting/start')
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		display:block;
		background-color: #ffffff;
	}
	@media (max-width: 768px){
		.root {
			.ResultBox{
				padding-top: 60px;
			}
		}
	}
</style>